// extracted by mini-css-extract-plugin
export default {"accepted":"cateringStatus_accepted__SYGcV","declined":"cateringStatus_declined__TV9Bi","open":"cateringStatus_open__TIByd"};